import { setIn } from 'formik';

export default function setAddressField(state, { type, payload: { path, value } }) {
  return setIn(state, path, value);
}
